/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Step_Book_TitleInputs */

const en_portal_step_book_title = /** @type {(inputs: Portal_Step_Book_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book a time`)
};

const pl_portal_step_book_title = /** @type {(inputs: Portal_Step_Book_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zarezerwuj termin`)
};

/**
* | output |
* | --- |
* | "Book a time" |
*
* @param {Portal_Step_Book_TitleInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_step_book_title = /** @type {((inputs?: Portal_Step_Book_TitleInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Step_Book_TitleInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_step_book_title(inputs)
	return en_portal_step_book_title(inputs)
});